import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { AdminListComponent } from './admin-list.component';
import { SubscriptionModel } from '../../subscription/subscription.model';
import { AdminService } from '../admin.service';
import { UserService } from '../../user/user.service';
import { AdminData } from './adminData.model';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-adminsuscriptiondialog',
    templateUrl: './suscription-dialog.component.html',
    styleUrls: ['./admin.component.css'],
    standalone: false
})

export class SuscriptionAdminDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AdminListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public adminService: AdminService,
    public userService: UserService
  ) { }

  userUid: string = this.data.userUid;
  suscriptions: SubscriptionModel[] = [];
  user: AdminData;
  ready = false;

  public get suscriptionsOptions(): Option[] {
    return (this.suscriptions || []).map(type => ({ label: type.type, value: type.uid }));
  }

  ngOnInit() {
    this.adminService.GetUser(this.userUid).then(userData => {
      this.user = userData;
      this.adminService.GetSuscriptions().then(result => {
        this.suscriptions = result;
        this.ready = true;
      })
    });
  }

  assignSub() {
    this.user.isActivated = true;
    this.user.isSubscribed = true;
    const sub = this.suscriptions.find(x => x.uid == this.user.subscriptionUid);
    this.user.subscriptionType = sub.type;
    this.adminService.ChangeUserData(this.user).then(result => {
      this.closeDialog();
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
